module.exports = __webpack_public_path__ + "media/images/marketing-banner/marketing-banner-bg-803436c20c505a500c51098332b36d5a.jpg";